import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { roleGuard } from '@core/guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/business',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    redirectTo: '/inventaire',
    pathMatch: 'full'
  },
  {
    path: 'business',
    loadChildren: () => import('./features/business/business.routes').then(m => m.BUSINESS_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'inventaire',
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'inventory',
    loadChildren: () => import('./features/inventory/inventory.routes').then(m => m.INVENTORY_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'invoices',
    loadChildren: () => import('./features/invoice-scanner/invoice-scanner.routes').then(m => m.INVOICE_SCANNER_ROUTES),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['admin'] }
  },
  {
    path: 'work',
    loadChildren: () => import('./features/work/work.routes').then(m => m.WORK_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'mindmap',
    loadChildren: () => import('./features/mindmap/mindmap.routes').then(m => m.MINDMAP_ROUTES),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['admin', 'collaborator'] }
  },
  {
    path: 'social-media',
    loadChildren: () => import('./features/social-media/social-media.routes').then(m => m.SOCIAL_MEDIA_ROUTES),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['admin', 'social_admin', 'social_approver', 'social_editor'] }
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./shared/components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./shared/components/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
